export const TASK_CONSTRUCTOR_PATH = '/processes/task-constructor';
